import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ModalsContainer = _resolveComponent("ModalsContainer")!
  const _component_PToast = _resolveComponent("PToast")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_router_view, {
      dir: "ltr",
      class: "font-sans"
    }),
    _createVNode(_component_ModalsContainer),
    _createVNode(_component_PToast, { position: "top-right" })
  ]))
}